import Vue from 'vue';
import * as types from '../actionTypes';
import uniqueKey from '../../helpers/uniqueKey';

const state = () => {
    return {
        data: {}
    }
};

const getters = {
};

const actions = {
    [types.SHOW_NOTIFICATION]({ commit }, payload) {
        const id = uniqueKey();

        commit(types.ADD_NOTIFICATION, { id, data: payload });

        /** remove notification after 10 seconds **/
        setTimeout(() => commit(types.REMOVE_NOTIFICATION, id), 10000);
    }
};

const mutations = {
    [types.ADD_NOTIFICATION](state, payload) {
        Vue.set(state.data, payload.id, payload.data)
    },
    [types.REMOVE_NOTIFICATION](state, payload) {
        Vue.delete(state.data, payload)
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
